module.exports = __webpack_public_path__ + "img/public/SiteIcons/viewCarsIcon.svg?1dd85cb4";